import {} from '@famly/stat_forms_stat-form';
import {} from './kinder-connect-capture-form-values';
export const defaultConfig = {};
